import { getFontSize } from '../../constants/fontSizes';

export const reusableTextFieldStyles = (textColor = '#1F1F1F', error = false) => ({
  '& .MuiOutlinedInput-root': {
    color: textColor,
    borderRadius: '14px',
    gap: '10px',
    boxShadow: error ? '0px 0px 0px 3px rgba(211, 47, 47, 0.2)' : 'none',
    '&.MuiInputBase-multiline': {
      padding: 0,
    },
    '& fieldset': {
      borderColor: error ? '#D32F2F' : '#EAEAEA',
      borderWidth: {xs: '1px', md: '2px'},
      
    },
    '&:hover fieldset': {
        borderColor: error ? '#D32F2F' : '#EAEAEA',
        borderWidth: {xs: '1px', md: '2px'},
    },
    '&.Mui-focused fieldset': {
      borderColor: error ? '#D32F2F' : '#EAEAEA',
      borderWidth: {xs: '1px', md: '2px'},
    },
    '& input': {
      paddingTop: '17px',
      paddingRight: { xs: '15px', md: '24px' },
      paddingBottom: '17px',
      paddingLeft: { xs: '15px', md: '24px' },
      fontSize: getFontSize(18),
    },
    '& textarea': {
      paddingTop: '17px',
      paddingRight: { xs: '15px', md: '24px' },
      paddingBottom: '17px',
      paddingLeft: { xs: '15px', md: '24px' },
      fontSize: getFontSize(1),
    },
    '& .MuiInputBase-inputMultiline': {
      paddingTop: '17px',
      paddingRight: { xs: '15px', md: '24px' },
      paddingBottom: '17px',
      paddingLeft: { xs: '15px', md: '24px' },
      fontSize: getFontSize(18),
    },
    '& input::placeholder': {
      color: '#7b7b7b',
      opacity: 1,
    },
    '& textarea::placeholder': {
      color: '#7b7b7b',
      opacity: 1,
    },
    '& .MuiSelect-select': {
      paddingTop: '17px',
      paddingRight: { xs: '15px', md: '24px' },
      paddingBottom: '17px',
      paddingLeft: { xs: '15px', md: '24px' },
      fontSize: getFontSize(18),
    },
    '& .MuiSelect-icon': {
      color: '#7b7b7b',
      right: '24px',
    },
  },
  '& .MuiInputLabel-root': {
    color: '#7b7b7b',
    fontSize: getFontSize(18),
    paddingLeft: '5px',
    '&.Mui-focused': {
      color: '#7b7b7b',
    },
    '&.Mui-error': {
      color: '#D32F2F',
    },
  },
  '& .MuiFormHelperText-root': {
    marginLeft: '5px',
    marginTop: '4px',
    fontSize: getFontSize(18),
    '&.Mui-error': {
      color: '#D32F2F',
    },
  },
});

